import { useState } from "react";
import { TripTable } from "@/app/Cities/Trips/Components/TripTable";
import { CityFilter } from "@/lib/Components/DataTable/Filters/CityFilter";

export function AdminTripsScreen() {
  const [cityId, setCityId] = useState<string>();
  const [otherCityId, setOtherCityId] = useState<string>();
  const cityIds = [cityId, otherCityId].filter((id) => id !== undefined);

  return (
    <div className="space-y-6">
      <h1 className="text-base font-semibold leading-6 text-gray-900">Trips</h1>
      <TripTable
        id="admin-trips"
        queryVariables={{ cityIds: cityIds.length ? cityIds : undefined }}
        filters={
          <div className="flex flex-wrap gap-2">
            <CityFilter
              placeholder="City"
              selected={cityId ? [cityId] : []}
              onChange={(ids) => setCityId(ids.at(-1))}
            />
            <CityFilter
              placeholder="Other city"
              selected={otherCityId ? [otherCityId] : []}
              onChange={(ids) => setOtherCityId(ids.at(-1))}
            />
          </div>
        }
      />
    </div>
  );
}
